/*
 * ScalePicker — 1–5 scale directive.
 *
 * Agent calls `render(directive_type='bubble_scale', payload={min,
 * max, labels?})` for the rare cases where a numeric scale is the
 * right answer shape — e.g. "How confident are you in this estimate?
 * 1 (just a guess) → 5 (locked)."
 *
 * Brand: small ladder of brand-50 tiles, brand-blue on the picked one.
 */

import React, { useState } from 'react';

import type { DirectivePayload } from '../../lib/dossier-types';


export interface ScalePickerProps {
  payload: DirectivePayload;
  onPick: (value: number) => void;
  disabled?: boolean;
}


export const ScalePicker: React.FC<ScalePickerProps> = ({ payload, onPick, disabled }) => {
  const min = typeof payload.min === 'number' ? payload.min : 1;
  const max = typeof payload.max === 'number' ? payload.max : 5;
  const labels = payload.labels || [];
  const [picked, setPicked] = useState<number | null>(null);

  const values: number[] = [];
  for (let v = min; v <= max; v += 1) values.push(v);

  return (
    <div className="aa-directive aa-directive--scale">
      <div className="aa-directive-scale-row">
        {values.map((v, i) => (
          <button
            key={v}
            type="button"
            disabled={disabled}
            onClick={() => { setPicked(v); onPick(v); }}
            className={
              'aa-directive-scale-tile'
              + (picked === v ? ' aa-directive-scale-tile--on' : '')
            }
          >
            <span className="aa-directive-scale-num">{v}</span>
            {labels[i] && <span className="aa-directive-scale-label">{labels[i]}</span>}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ScalePicker;
